/**
 * Collection banner cart bundle progress - sticky behavior and close button
 * Handles header-sticky (top) and sticky (bottom) modes
 */
(function () {
  const STORAGE_KEY = 'collectionBannerProgressClosed';

  function getBannerSection() {
    return document.querySelector('.collection-hero[data-section-id]');
  }

  function getProgressMode() {
    const section = getBannerSection();
    return section?.dataset?.progressMode || 'off';
  }

  function isClosedThisSession() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }

  function setClosedThisSession() {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch {}
  }

  function getStickyBar() {
    return document.getElementById('cart-bundle-progress-collection-sticky-header');
  }

  function getHeaderHeight() {
    const header = document.querySelector('.header-wrapper');
    return header ? header.offsetHeight : 0;
  }

  function updateStickyVisibility() {
    const mode = getProgressMode();
    if (mode === 'off') return;

    const bar = getStickyBar();
    if (!bar) return;

    if (isClosedThisSession()) {
      bar.setAttribute('hidden', '');
      return;
    }

    if (mode === 'sticky') {
      bar.removeAttribute('hidden');
      bar.setAttribute('aria-hidden', 'false');
      return;
    }

    if (mode === 'header_sticky') {
      const banner = getBannerSection();
      if (!banner) return;
      const rect = banner.getBoundingClientRect();
      const headerHeight = getHeaderHeight();
      if (rect.bottom < headerHeight) {
        bar.removeAttribute('hidden');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.setAttribute('hidden', '');
        bar.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function initCloseButtons() {
    document.querySelectorAll('.cart-bundle-progress-sticky-header__close').forEach((btn) => {
      if (btn.dataset.progressCloseBound) return;
      btn.dataset.progressCloseBound = 'true';
      btn.addEventListener('click', () => {
        setClosedThisSession();
        getStickyBar()?.setAttribute('hidden', '');
      });
    });
  }

  function init() {
    const section = getBannerSection();
    if (!section || getProgressMode() === 'off') return;

    initCloseButtons();

    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateStickyVisibility();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateStickyVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail?.sectionId && document.querySelector(`[data-section-id="${e.detail.sectionId}"]`)) {
      init();
    }
  });
})();
